import { useMutation } from "@tanstack/react-query";
import { createEmployee as apiCreate } from "../../api/apiEmployees";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useCreateEmployee() {
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const { mutate: createEmployee, isPending, error } = useMutation({
        mutationFn: (req) => apiCreate(req),
        onSuccess: (r) => { enqueueSnackbar(r.message, { variant: "success" }); navigate('/employees'); },
        onError: (err) => { enqueueSnackbar(getErrorMessageFromAxiosError(err), { variant: "error" }); },
    });
    return { isPending, error, createEmployee };
}
